import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    confirm: 'Return home',
    description:
      'Your request has been registered and our teams will take care of everything.\nThis offer is valid once per account.',
    title: 'Well received!',
  },
  fr: {
    confirm: 'Revenir à l’accueil',
    description:
      'Votre demande a bien été enregistrée, nos équipes s’occupent de tout.\nCette offre est valable une seule fois par compte.',
    title: 'Bien reçu !',
  },
} as const);
